<app-header></app-header>

<div class="page-title-area page-title-style-two despre-bg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Despre Noi</li>
            </ul>
            <h2>Despre Noi</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="about-content left-content">
                    <span class="sub-title">DESPRE C.M.D.T.A.M.P</span>

                    <p>
                        Centrul Medical de diagnostic, tratament ambulatoriu si medicina preventiva(CMDTAMP) –
                        Bucuresti, are un corp medical de peste 150 de medici (medicina de familie si medici
                        specialisti) care asigura servicii de specialitate:
                    </p>
                    <ul>
                        <li>Alergologie</li>
                        <li>Cardiologie</li>
                        <li>Dermatologie</li>
                        <li>Chirurgie</li>
                        <li>Dermatologie estetica</li>
                        <li>Diabet</li>
                        <li>boli nutritie</li>
                        <li>Ecografie</li>
                        <li>Endocrinologie</li>
                        <li>Fizioterapie si Recuperare medicala</li>
                        <li>Gastroenterologie</li>
                        <li>Ginecologie</li>
                        <li>Medicina generala</li>
                        <li>Kinetoterapie</li>
                        <li>Medicina interna</li>
                        <li>Medicina muncii</li>
                        <li>Neurologie</li>
                        <li>Oftalmologie</li>
                        <li>Orl si audiometrie</li>
                        <li>Pneumologie</li>
                        <li>Psihiatrie pediatrica</li>
                        <li>Psihiatrie</li>
                        <li>Psihologie</li>
                        <li>Reumatologie</li>
                        <li>Stomatologie</li>
                        <li>Urologie</li>



                    </ul>
                    <p>De asemeni, centrul medical dispune de un serviciu ambulanta propriu, centru de hemodializa,
                        Laborator de analize paraclinice pentru o gama larga de determinari, Farmacie proprie, un
                        laborator de imagistica dotat cu Computer tomograf, radiologie digitala, mamografie ecografie si
                        Eco- Doppler.</p>
                    <p>Centrul medical asigura tratamente de insuficienta renala cronica, prin sectia de dializa, baza
                        de tratament balneofizioterapie, cat si tratamente oncologice de chimioterapie.</p>
                    <p>Ca un specific al centrului medical , asiguram anumite tratamente chirurgicale, in cadrul
                        urmatoarelor specialitati : ortopedie, oftalmologie, flebologie, ORL, chirurgie
                        buco-maxilo-faciala, microchirugie, ginecologie.</p>
                    <p>Asiguram asistenta medicala primara, de specialitate, de urgenta pentru categoriile de persoane
                        aflate in sistemul de asigurari sociale de sanatate, asistenta medicala si protectie sanitara
                        pentru demnitarii romani si straini, activitati de inspectie sanitara si sanitar-veterinara de
                        stat.</p>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="about-right-image">
                    <img src="assets/img/about/about4.jpg" alt="image">
                    <img src="assets/img/about/about3.jpg" alt="image">
                </div>
            </div>
        </div>
    </div>
</div>
